<template>
  <v-autocomplete
    hide-details
    v-model="dua_reason_code"
    :items="orderedDuaReasonCodes"
    item-text="text"
    item-value="code"
    clearable
    outlined
    dense
    label="Orsak"
    class="pt-1"
    :loading="$apollo.loading"
    :disabled="item.missing || isHistoryEvent"
    :append-icon="
      isDiff('dua_reason_code') ? 'mdi-alert-octagram' : 'mdi-menu-down'
    "
  />
</template>

<script>
import gql from 'graphql-tag'
import { get } from 'vuex-pathify'
import { format } from 'date-fns'
import orderBy from 'lodash.orderby'

const getSet = prop => ({
  get() {
    return this.form[this.uuid].data[prop]
  },

  set(v) {
    let value = v
    if (!value || !value.length) {
      value = null
    }
    const form = Object.assign({}, this.form)
    form[this.uuid].data[prop] = value
    this.$store.dispatch('duaMessage/updateForm', {
      uuid: this.uuid,
      prop,
      value
    })
  }
})

export default {
  name: 'DuaMessageReasonField',

  props: {
    item: Object,
    uuid: String
  },

  apollo: {
    duaCancellationCodes: {
      query: gql`
        query duaCancellationCodes {
          duaCancellationCodes {
            code
            text
          }
        }
      `
    },
    duaReasonCodes: {
      query: gql`
        query duaReasonCodes {
          duaReasonCodes {
            code
            text
          }
        }
      `
    }
  },

  computed: {
    isHistoryEvent: get('history/isHistoryEvent'),

    form: get('duaMessage/form'),

    model: get('duaMessage/model'),

    dua_reason_code: {
      ...getSet('dua_reason_code')
    },

    orderedDuaReasonCodes() {
      return orderBy(this.duaReasonCodes || [], ['text'], ['asc'])
    },

    currentTrip() {
      return this.model?.body?.find(x => x?.trip_uuid === this.uuid)
    }
  },

  methods: {
    isDiff(prop) {
      if (!this.currentTrip) return false
      const currentProp = this.currentTrip.data[prop] || null
      const formProp = this.form[this.uuid].data[prop] || null
      if (currentProp && formProp && prop === 'estimated_time_at_location') {
        return (
          format(new Date(currentProp), 'yyyy-MM-dd HH:mm') !==
          format(new Date(formProp), 'yyyy-MM-dd HH:mm')
        )
      }
      return currentProp !== formProp
    }
  }
}
</script>
